import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initGtag } from "@/lib/gtag";

const PerformanceTest = lazy(() => import("@/pages/PerformanceTest"));
const Admin = lazy(() => import("@/pages/Admin"));
const AuthCallback = lazy(() => import("@/pages/AuthCallback"));
const FanCoil = lazy(() => import("@/pages/FanCoil"));
const CityPage = lazy(() => import("@/pages/CityPage"));
const Aszf = lazy(() => import("@/pages/Aszf"));
const Adatvedelem = lazy(() => import("@/pages/Adatvedelem"));

initGtag();

const QUERY_STALE_TIME_MS = 60_000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: QUERY_STALE_TIME_MS,
      retry: 1,
    },
  },
});

function AppRouter() {
  const location = useLocation();
  // Synchronous check: process OAuth session_id BEFORE any route/auth logic runs
  const fallback = <div className="min-h-screen bg-[var(--bg)]" />;
  if (location.hash?.includes("session_id=")) {
    return <Suspense fallback={fallback}><AuthCallback /></Suspense>;
  }
  return (
    <Suspense fallback={fallback}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/teszt" element={<PerformanceTest />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/fan-coil" element={<FanCoil />} />
        <Route path="/klimatisztitas-balatonszarszo" element={<CityPage cityKey="balatonszarszo" />} />
        <Route path="/klimatisztitas-balatonlelle" element={<CityPage cityKey="balatonlelle" />} />
        <Route path="/aszf" element={<Aszf />} />
        <Route path="/adatvedelem" element={<Adatvedelem />} />
      </Routes>
    </Suspense>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
